// extracted by mini-css-extract-plugin
module.exports = {"root":"how-it-works_root__dkrhC","title":"how-it-works_title__OX7Ad","cardList":"how-it-works_cardList__CyUV_"};